import { createFileRoute, Navigate } from '@tanstack/react-router';
import CreateCase from '../../../../Components/CreateCase';
import { useCanViewCases } from '../../../../Hooks/featurePermission';
import { useFeaturePermissionsLoaded } from '../../../../Selectors/Permission';

export const Route = createFileRoute('/(main)/_layout/cases/new')({
  component: RouteComponent,
});

function RouteComponent() {
  const featurePermissionsLoaded = useFeaturePermissionsLoaded();
  const canViewCases = useCanViewCases();

  // Wait for permissions to load before deciding whether to redirect.
  if (!featurePermissionsLoaded) {
    return null;
  }

  if (!canViewCases) {
    return <Navigate to="/chats" />;
  }

  return <CreateCase />;
}
